// extracted by mini-css-extract-plugin
export default {"short_clip":"style_short_clip__GruZV","skeletonLoader":"style_skeletonLoader__8q24a","shimmer":"style_shimmer__mJcvm"};